import { render } from "./LocaleComponent.vue?vue&type=template&id=644d5d9a&scoped=true&ts=true"
import script from "./LocaleComponent.vue?vue&type=script&lang=ts"
export * from "./LocaleComponent.vue?vue&type=script&lang=ts"

import "./LocaleComponent.vue?vue&type=style&index=0&id=644d5d9a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-644d5d9a"]])

export default __exports__